import React from 'react';
import classNames from 'classnames';
import { SOFT_SIGNALS, SoftSignal } from 'models/Lead';
import FacedDownPalm from 'icons/FacedDownPalm';
import LikeIcon from 'icons/Like.icon';

import './SoftSignalIcon.styles.scss';

type SoftSignalIconProps = {
  className?: string;
  softSignal: SoftSignal;
  transparent?: boolean;
};

const SoftSignalIcon: React.FC<SoftSignalIconProps> = (props) => {
  const { className, softSignal, transparent = false } = props;

  const classes = classNames(
    'soft-signal-icon',
    softSignal,
    { transparent },
    className,
  );

  if (!softSignal) return null;

  if (softSignal === SOFT_SIGNALS.UNSURE)
    return <FacedDownPalm className={classes} />;

  return <LikeIcon className={classes} />;
};

export default SoftSignalIcon;
